import { RouteUpdatedEvent } from '@rematter/frontend-lib-api-client/grpc/transportation/v1/route_events_pb';
import { Col, DiffViewer, FieldDisplay, IDField } from '@rematter/ui-web';

import { routeStatusLabels } from '../enumLabels';

type RouteUpdatedDetailProps = {
  event: RouteUpdatedEvent;
};

export const RouteUpdatedDetail = ({ event }: RouteUpdatedDetailProps) => {
  const previous = event.previousRoute;
  const current = event.updatedRoute;

  if (!previous || !current) {
    return (
      <Col className="@RouteUpdatedDetail items-center justify-center p-4 text-neutral/40">
        <span>No data available</span>
      </Col>
    );
  }

  const diffs = [
    {
      field: 'documentNumber',
      label: 'Document Number',
      previous: previous.documentNumber ? String(previous.documentNumber) : '',
      current: current.documentNumber ? String(current.documentNumber) : '',
    },
    {
      field: 'status',
      label: 'Status',
      previous: routeStatusLabels[previous.status],
      current: routeStatusLabels[current.status],
    },
    {
      field: 'rank',
      label: 'Rank',
      previous: previous.rank,
      current: current.rank,
    },
    {
      field: 'priority',
      label: 'Priority',
      previous: previous.priority ? String(previous.priority) : '',
      current: current.priority ? String(current.priority) : '',
    },
    {
      field: 'description',
      label: 'Description',
      previous: previous.description,
      current: current.description,
    },
    {
      field: 'notes',
      label: 'Notes',
      previous: previous.notes,
      current: current.notes,
    },
    {
      field: 'driverId',
      label: 'Driver ID',
      previous: previous.driverId?.value ?? '',
      current: current.driverId?.value ?? '',
    },
    {
      field: 'haulerId',
      label: 'Hauler ID',
      previous: previous.haulerId?.value ?? '',
      current: current.haulerId?.value ?? '',
    },
    {
      field: 'truckId',
      label: 'Truck ID',
      previous: previous.truckId?.value ?? '',
      current: current.truckId?.value ?? '',
    },
    {
      field: 'trailerId',
      label: 'Trailer ID',
      previous: previous.trailerId?.value ?? '',
      current: current.trailerId?.value ?? '',
    },
    {
      field: 'facilityGroupId',
      label: 'Facility Group ID',
      previous: previous.facilityGroupId?.value ?? '',
      current: current.facilityGroupId?.value ?? '',
    },
  ];

  return (
    <Col className="@RouteUpdatedDetail gap-3" gap3>
      <Col className="rounded-md border border-neutral/10 bg-white p-3" gap2>
        <span className="text-xs font-medium text-neutral/60">Route</span>
        <div className="grid grid-cols-2 gap-x-4 gap-y-1">
          <IDField label="ID" value={current.id?.value} />
          <FieldDisplay
            label="Document Number"
            value={current.documentNumber ? String(current.documentNumber) : ''}
          />
        </div>
      </Col>

      <Col className="rounded-md border border-neutral/10 bg-white p-3" gap1>
        <span className="mb-2 text-xs font-medium text-neutral/60">
          Changes
        </span>
        <DiffViewer diffs={diffs} previousLabel="Before" currentLabel="After" />
      </Col>
    </Col>
  );
};
